import { availableLocales, getUserLocales, mergeUserLocales } from './index.js';
export const preferredLocale = (fallback, appLocales, options = {}) => {
    if (!options.regionLowerCase)
        options.regionLowerCase = false;
    if (!options.languageOnly)
        options.languageOnly = false;
    const userLocales = getUserLocales(options);
    const mergedUserLocales = mergeUserLocales([...userLocales, fallback], options);
    const matchedLocales = availableLocales(mergedUserLocales, appLocales, options);
    return matchedLocales[0] || fallback;
};
